import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type MarketSettingsUsersSubscriptionAccessController from 'lumen/controllers/market/settings/users/subscription-access';
import type { Transition } from 'lumen/services/transition';

export default class MarketSettingsUsersSubscriptionAccessRoute extends Route {
  queryParams = {
    userId: { refreshModel: true },
    userEmail: { refreshModel: false },
  };

  @service declare router: Services['router'];

  usersRouteName = 'market.settings.users';

  beforeModel(transition: Transition): void {
    const userId = transition.to?.queryParams?.['userId'];

    if (!userId) {
      this.router.transitionTo(this.usersRouteName);
    }
  }

  // Without an overridden model hook, Ember treats query-param-only
  // (refreshModel) transitions as a no-op and skips setupController, so
  // switching userId would update the URL but never reload the modal.
  // Returning a fresh object on every call is enough to make Ember
  // re-run setupController each time.
  model(): object {
    return {};
  }

  setupController(
    controller: MarketSettingsUsersSubscriptionAccessController,
    model: unknown,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    void controller.resetAndLoad();
  }
}
